import { useTranslations } from '@fshr/context/i18n-context';
import { ArrowRight } from '../icon/arrow-right';
import Image from '../image';
import Link from '../link';

type ImageProps = {
	url: string;
	alt?: string;
};

export type OutletsInfoType = {
	name: string;
	image: ImageProps;
	detailPageUrl?: string;
};

type ReserveTableCardProps = OutletsInfoType;

type ReserveTableSectionProps = {
	outlets: OutletsInfoType[];
	landingUrl?: string;
};

function ReserveTableCard(props: ReserveTableCardProps) {
	const { detailPageUrl = '', image, name } = props;
	const t = useTranslations();

	return (
		<div role="listitem">
			<Link
				href={detailPageUrl}
				aria-label={`dining outlet - ${name}`}
				tabIndex={0}
				intent="unstyled"
				className="w-[150px] h-[181px] flex flex-row relative"
			>
				<Image
					roughSize="s"
					className="w-[150px] h-[181px] object-cover"
					src={image.url}
					alt={image.alt ?? t(`Dining Outlet Image - ${name}`)}
				/>
				<div
					aria-hidden={true}
					className="absolute flex flex-col justify-end bottom-0 left-0 gap-[5px] p-100 w-full min-h-[50%] card-gradient"
				>
					<h3 className="text-white text-subtitle2 max-w-[126px]">{name}</h3>
					<p className="text-white text-label">{t('Reserve')}</p>
				</div>
			</Link>
		</div>
	);
}

export function ReserveTableSection(props: ReserveTableSectionProps) {
	const { outlets, landingUrl } = props;
	const t = useTranslations();

	return (
		<section className="py-150 px-200 md:py-200 md:px-300" aria-label={t('Reserve Table Section')}>
			<div className="flex flex-row justify-between items-center spacing-heading-s">
				<h2 className="tablet-heading-h4">{t('Reserve a table')}</h2>
				{landingUrl ? (
					<Link
						href={landingUrl + `?_s_icmp=itineraryoverlay_viewalloutlets`}
						intent="unstyled"
						className="text-button2 text-button-primary flex flex-row gap-[10px]"
						aria-label={t('View All')}
						tabIndex={0}
					>
						{t('View All')} <ArrowRight />
					</Link>
				) : null}
			</div>

			<div
				className="w-full flex flex-row flex-wrap gap-150 pr-[6px] md:gap-auto md:pr-0 md:spacing-inline-s"
				role="list"
			>
				{outlets.map(({ image, name, detailPageUrl }, index) => (
					<ReserveTableCard
						image={image}
						name={name}
						detailPageUrl={detailPageUrl}
						key={`outlet-dinning-info-card-${index}-${name}`}
					/>
				))}
			</div>
		</section>
	);
}
